import exponent from "./exponent";

export default function(step) {
  return Math.max(0, -exponent(Math.abs(step)));
}



//////////////////
// WEBPACK FOOTER
// ../~/d3-format/src/precisionFixed.js
// module id = EyKk
// module chunks = 0